export default __webpack_public_path__ + "static/media/AGATA.4bcfedb4.jpg";